import React from "react";
import { HiddenVisually, Box, SheetContainer, Text, Icon, ListItem, Button, Stack, } from "@bookingcom/bui-react";
import { CheckmarkIcon } from "@bookingcom/bui-assets-react/streamline";
import { getSelectedItem, prepareSelectionItems } from "./Picker.utilities";
import "./Picker.types";
import styles from "./Picker.module.css";
function PickerTrigger(_a) {
    var children = _a.children, shouldDisplaySelectionTitle = _a.shouldDisplaySelectionTitle, selection = _a.selection, selected = _a.selected, attributes = _a.attributes, renderSign = _a.renderSign, renderSelectedSign = _a.renderSelectedSign, onClick = _a.onClick;
    if (shouldDisplaySelectionTitle) {
        return (React.createElement(ListItem, { spacing: "large", attributes: attributes, className: styles["selection-trigger"], startSlot: renderSelectedSign
                ? renderSelectedSign(selected)
                : renderSign(selected), onClick: onClick }, children || (React.createElement(React.Fragment, null,
            React.createElement(HiddenVisually, null, selection.title),
            selected.title))));
    }
    return (React.createElement(Button, { variant: "tertiary-inherit", attributes: attributes, onClick: onClick }, children || (React.createElement(Stack, { direction: "row", alignItems: "center", tagName: "span", gap: 0 },
        renderSelectedSign
            ? renderSelectedSign(selected)
            : renderSign(selected),
        React.createElement(HiddenVisually, null, selection.title)))));
}
function PickerMobile(props) {
    var children = props.children, selection = props.selection, selectedId = props.selectedId, _a = props.shouldDisplaySelectionTitle, shouldDisplaySelectionTitle = _a === void 0 ? true : _a, triggerAttributes = props.triggerAttributes, attributes = props.attributes, renderSign = props.renderSign, renderSelectedSign = props.renderSelectedSign, onOpen = props.onOpen, onClose = props.onClose;
    var all = selection.all, popular = selection.popular;
    var selected = getSelectedItem(selection, selectedId);
    var _b = React.useState(false), modalActive = _b[0], setModalActive = _b[1];
    if (!selected)
        return null;
    var open = function () {
        setModalActive(true);
        if (selection.onOpen)
            selection.onOpen();
        if (onOpen)
            onOpen();
    };
    var close = function () {
        setModalActive(false);
        if (onClose)
            onClose();
    };
    var handleItemChoose = function (item, index) {
        selection.onChoose(item, index);
        close();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PickerTrigger, { shouldDisplaySelectionTitle: shouldDisplaySelectionTitle, selection: selection, selected: selected, attributes: triggerAttributes, onClick: open, renderSign: renderSign, renderSelectedSign: renderSelectedSign }, children),
        React.createElement(SheetContainer, { fill: true, position: "fullScreen", arrowNavigation: true, ariaLabel: selection.title, active: modalActive, closeAriaLabel: selection.closeAriaLabel, attributes: attributes, onCloseTrigger: close },
            React.createElement("div", { className: styles["mobile-content"] },
                React.createElement(Box, { padding: 6 },
                    React.createElement(Text, { variant: "headline_2", tagName: "h2" }, selection.title),
                    selection.disclaimer),
                [popular, all].map(function (section, index) {
                    if (!section)
                        return null;
                    var items = prepareSelectionItems(section.items, selectedId, !index);
                    if (!items.length)
                        return null;
                    return (React.createElement("div", { key: section.title, "data-testid": section.title },
                        !!popular && (React.createElement(Text, { variant: "strong_2", tagName: "h3", className: styles["menu-title"] }, section.title)),
                        React.createElement("ul", null, items.map(function (item) {
                            var active = item.id === selectedId;
                            var endSlot = active && (React.createElement(Icon, { svg: CheckmarkIcon, size: "large" }));
                            return (React.createElement("li", { key: item.id },
                                React.createElement(ListItem, { startSlot: renderSign(item), endSlot: endSlot, spacing: "large", onClick: function () { return handleItemChoose(item, index); }, active: active, href: item.href, attributes: { "data-testid": "selection-item" } },
                                    React.createElement("span", { className: styles["selection-text"] }, item.title))));
                        }))));
                })))));
}
export default PickerMobile;
